export default __webpack_public_path__ + "static/media/subscribe-banner 1.a128e71c.png";